export const MATTER_SEARCH_SORT_FIELDS: Record<string, string> = {
  Assignees: "assigneeName",
  Client: "clientName",
  "Client Email": "clientEmail",
  "Client Phone": "clientPhone",
  "Date Created": "dateCreated",
  "Date Modified": "dateModified",
  "Date of Loss": "dateOfLoss",
  "Incident Description": "incidentDescription",
  "Injury Description": "clientInjuryDescription",
  "Defendant(s)": "defendantName",
  "Incident Address": "incidentAddress",
  "Insurance Claim Number": "insuranceClaimNumber",
  "Insurance Coverage": "insuranceCoverage",
  "Insurance Liability": "insuranceLiability",
  "Insurance Policy Number": "insurancePolicyNumber",
  "Matter Email": "emailAddress",
  "Medical Treatment Bill Total": "medicalTreatmentBillTotal",
  "Referred By": "referredBy",
  "Referred To": "referredTo",
  Status: "status",
  "Statute of Limitations": "statuteOfLimitations",
  Tags: "tag",
  Teams: "team",
  Title: "title",
  "Total Costs": "expenseTotal",
  "Incident Type": "incidentType",
};
